import { combineReducers } from 'redux';

import {
  fetchAnnouncementsTypes,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const main = makeRequestReducer({
  types: fetchAnnouncementsTypes,
  name: 'fetchAnnouncements',
});

export default combineReducers({
  main,
});



// WEBPACK FOOTER //
// ./src/modules/announcement/reducers.js